import { format } from "date-fns";
import React, { Fragment } from "react";

const DateFormatter = ({date, formatText = "d MMM yyyy, h:mm a"}) => {
  return <Fragment>{format(date, formatText)}</Fragment>; // format = 'MMMM d, yyyy'
};

export default DateFormatter;
